export const LicenseInfoDataGrid = {
    //license: '80014de3201f4c8353bfecb10e3ba4bbTz03MzcyOSxFPTE3MjUwMzA1MzkwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI='
    license: 'e0d9bb8070ce0054c9d9ecb6e82cb58fTz0wLEU9MzI0NzIxNDQwMDAwMDAsUz1wcmVtaXVtLExNPXBlcnBldHVhbCxLVj0y'
}

//Clave utilizada para el consumo de la API de Google Drive
export const accessKey = "AIzaSyDZ6hH50ScBqGoOQOMUD2AVNKpPfkBaSOI"

if(localStorage.getItem("clientData") === null){
    localStorage.setItem(
        "clientData",
        JSON.stringify({
            owner_code: "",
            dominio: "",
            api_pass: "",
        })
    );
}

export const configS3 = {
    bucketName: JSON.parse(localStorage.getItem("siam-params-images"))?.BUCKET_NAME?.value ? JSON.parse(localStorage.getItem("siam-params-images"))?.BUCKET_NAME?.value : '',
    region: 'us-east-1', // Región global de S3 
    accessKeyId: JSON.parse(localStorage.getItem("siam-params-images"))?.PUBLIC_KEY?.value ? JSON.parse(localStorage.getItem("siam-params-images"))?.PUBLIC_KEY?.value : '' ,
    secretAccessKey: JSON.parse(localStorage.getItem("siam-params-images"))?.PRIVATE_KEY?.value ? JSON.parse(localStorage.getItem("siam-params-images"))?.PRIVATE_KEY?.value : ''
  };

export const config = {
    credentials: {
        authorization: {
            owner_code: JSON.parse(localStorage.getItem("clientData")).owner_code,
            id_user: "1",
            language: "es",
        },
    },
    authToken: localStorage.getItem("authToken"),
    };

export const appName = JSON.parse(localStorage.getItem("clientData")).owner_descripcion

export const id_proyecto = "27" // Se cambia de acuerdo al proyecto al cual esta dirigido el sistema

export const parametros_proyecto = [
    { id: "27", nombre: "DLyS Santa Fe", usar_video_login: true, url_video: "src/video/D-Box.mp4", usar_imagen_login: false, url_imagen: "https://siam-srv.krakenlab.com.ar/static_content/img/DLYS_LOGO.JPG", codigo_iso_moneda: "ARS", key_encript: "a1b2c3d4e5f678901234567890abcdefa1b2c3d4e5f678901234567890abcdef", aws_id_grupo_user: "us-east-1_IicsmhSD0", aws_id_cliente_aplicacion: "58lb2ugcj8ukmk2hl7q9sh4rbq", use_cognito: false},
    { id: "35", nombre: "DLyS Rosario", usar_video_login: true, url_video: "src/video/D-Box.mp4", usar_imagen_login: false, url_imagen: "https://siam-srv.krakenlab.com.ar/static_content/img/DLYS_ROS_LOGO.JPG", codigo_iso_moneda: "ARS", key_encript: "a1b2c3d4e5f678901234567890abcdefa1b2c3d4e5f678901234567890abcdef", aws_id_grupo_user: "us-east-1_IicsmhSD0", aws_id_cliente_aplicacion: "58lb2ugcj8ukmk2hl7q9sh4rbq", use_cognito: false},
    { id: "29", nombre: "SDE", usar_video_login: true, url_video: "src/video/D-Box.mp4", usar_imagen_login: false, url_imagen: "https://siam-srv.krakenlab.com.ar/static_content/img/SDE_LOGO.JPG", codigo_iso_moneda: "ARS", key_encript: "a1b2c3d4e5f678901234567890abcdefa1b2c3d4e5f678901234567890abcdef", aws_id_grupo_user: "us-east-1_IicsmhSD0", aws_id_cliente_aplicacion: "58lb2ugcj8ukmk2hl7q9sh4rbq", use_cognito: false},
    { id: "36", nombre: "MIT", usar_video_login: true, url_video: "src/video/D-Box.mp4", usar_imagen_login: false, url_imagen: "https://siam-srv.krakenlab.com.ar/static_content/img/MIT_LOGO.JPG", codigo_iso_moneda: "ARS", key_encript: "a1b2c3d4e5f678901234567890abcdefa1b2c3d4e5f678901234567890abcdef", aws_id_grupo_user: "us-east-1_IicsmhSD0", aws_id_cliente_aplicacion: "58lb2ugcj8ukmk2hl7q9sh4rbq", use_cognito: false}
]